/* =========================================================
   PTAH 2D VISUALIZER — print-on-photo with fabric folds
   Replaces the Three.js customizer on product.html.

   · Garment photo is AUTO-SELECTED from the configurator above
     (garment card click + color swatch change) — the visitor
     never uploads the garment, only their artwork.
   · Photo paths follow assets/img/viz/{garment}-{color}.jpg;
     until Rostik shoots them, a procedural washed-cotton
     placeholder is generated IN THE SWATCH'S EXACT COLOR, so
     the tool is fully usable today and upgrades itself the
     moment real files appear (image onerror → fallback).
   · Realism is fixed (no sliders): DISP 16 / SHADE .72 /
     sink-in-creases .08 / blur 4 + crease-edge darkening for
     a stronger fold transition (the v3 feedback).
   · Transform frame: drag body = move, corners = proportional
     resize, top knob = rotate. Tap OUTSIDE the print hides the
     frame (clean look); tap the print again to bring it back.
   ========================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-viz2d]');
  if (!root) return;

  var out = root.querySelector('[data-viz-canvas]');
  var ctx = out.getContext('2d', { willReadFrequently: true });
  var tip = root.querySelector('[data-viz-tip]');
  var MAXSIDE = 760;
  var DISP = 16, SHADE = 0.72, TEXTURE = 0.08, BLUR = 4;

  var S = { garment:null, print:null, map:null, grad:null,
            pos:{x:.5,y:.40}, scale:.42, rot:0, sel:true,
            gKey:'hoodie', cHex:'#1a1d1c', cName:'washed-black' };

  /* ---------- Garment photo: real file → procedural fallback ---------- */
  function slug(s){ return String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-'); }
  var _loadGen = 0; // generation counter — prevents stale/procedural from overwriting newer load

  function loadGarmentFromUrl(url, hex) {
    if (hex) S.cHex = hex;
    var gen = ++_loadGen;
    // crossOrigin='anonymous' HARD-FAILS the load when the server sends no
    // CORS headers (file://, plain static hosts) — and same-origin images
    // never need it. So: skip it for same-origin URLs, and on a CORS-mode
    // failure retry once without it (render falls back to flat compositing
    // if the canvas ends up tainted). Only a truly missing file gets the
    // procedural placeholder.
    var sameOrigin = true;
    try { sameOrigin = new URL(url, location.href).origin === location.origin; } catch (_) {}
    function attempt(useCors) {
      var img = new Image();
      if (useCors) img.crossOrigin = 'anonymous';
      img.onload = function(){
        if (gen !== _loadGen) return; // stale — a newer load already won
        setGarment(img);
      };
      img.onerror = function(){
        if (gen !== _loadGen) return;
        if (useCors) attempt(false);
        else setGarment(procedural(S.cHex));
      };
      img.src = url;
    }
    attempt(!sameOrigin);
  }
  function procedural(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex) || ['', '2e3331'];
    var n = parseInt(m[1], 16), R = (n>>16)&255, G = (n>>8)&255, B = n&255;
    var gw = 700, gh = 880, c = document.createElement('canvas');
    c.width = gw; c.height = gh;
    var gc = c.getContext('2d');
    gc.fillStyle = 'rgb(' + R + ',' + G + ',' + B + ')';
    gc.fillRect(0, 0, gw, gh);
    var im = gc.getImageData(0, 0, gw, gh), d = im.data;
    for (var y = 0; y < gh; y++) for (var x = 0; x < gw; x++) {
      var i = (y * gw + x) * 4;
      var f = Math.sin(x*0.012 + Math.sin(y*0.004)*4)*26
            + Math.sin((x*0.6+y)*0.006)*18
            + Math.sin(y*0.02 + x*0.002)*9;
      var nse = (Math.random()-0.5)*7;
      d[i]+=f+nse; d[i+1]+=f+nse; d[i+2]+=f+nse;
    }
    gc.putImageData(im, 0, 0);
    var img = new Image();
    img.src = c.toDataURL();
    return img; // dataURL images decode synchronously enough; render guards on naturalWidth
  }
  function setGarment(img) {
    var apply = function(){
      S.garment = img; S.map = null; S.grad = null;
      var k = Math.min(MAXSIDE/img.naturalWidth, MAXSIDE/img.naturalHeight, 1);
      out.width = Math.round(img.naturalWidth*k); out.height = Math.round(img.naturalHeight*k);
      schedule();
    };
    if (img.naturalWidth) apply(); else img.onload = apply;
  }

  /* ---------- Listen to configurator via ptah:garment-changed event ---------- */
  document.addEventListener('ptah:garment-changed', function(e) {
    var url = e.detail && e.detail.url;
    if (!url) return;
    loadGarmentFromUrl(url, e.detail.hex);
  });

  /* ---------- Print size → scale mapping ---------- */
  var PRINT_SCALE = { A6:.18, A5:.28, A4:.42, 'A3+':.58, small:.18, medium:.30, large:.44, back:.60 };
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-print-size]');
    if (!btn) return;
    var sc = PRINT_SCALE[btn.dataset.printSize];
    if (sc && S.print) { S.scale = sc; schedule(); }
  });

  /* ---------- Print upload ---------- */
  var fileInput = root.querySelector('[data-viz-file]');
  var upLabel = root.querySelector('[data-viz-uplabel]');
  var upName = root.querySelector('[data-viz-upname]');
  /* ---------- White-background keyer (luminance, soft edge) ----------
     Runs AUTOMATICALLY on upload (most artwork arrives on a white canvas)
     and stays available on the "Remove background" button for a re-run. */
  function removeWhiteBg(img, done){
    var w=img.naturalWidth, h=img.naturalHeight;
    if (!w || !h) { done(img); return; }
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    var cc=c.getContext('2d'); cc.drawImage(img,0,0);
    var im, d;
    try { im=cc.getImageData(0,0,w,h); d=im.data; }
    catch(_) { done(img); return; } // tainted (shouldn't happen for uploads)
    for (var i=0;i<d.length;i+=4){
      var r=d[i],g=d[i+1],b=d[i+2];
      var mx=Math.max(r,g,b), mn=Math.min(r,g,b), sat=mx-mn, lum=(r+g+b)/3;
      if (sat<32){
        if (lum>232) d[i+3]=0;
        else if (lum>200) d[i+3]=Math.min(d[i+3], (232-lum)/32*255);
      }
    }
    cc.putImageData(im,0,0);
    var ni=new Image();
    ni.onload=function(){ done(ni); };
    ni.src=c.toDataURL();
  }

  fileInput.addEventListener('change', function(e){
    var f = e.target.files && e.target.files[0]; if (!f) return;
    var fr = new FileReader();
    fr.onload = function(){
      var img = new Image();
      img.onload = function(){
        // auto-strip the white canvas before first render
        removeWhiteBg(img, function(clean){
          S.print = clean; S.scale=.42; S.rot=0; S.pos={x:.5,y:.40}; S.sel=true;
          upLabel.classList.add('has-file');
          upName.textContent = f.name.length>22 ? f.name.slice(0,22)+'…' : f.name;
          schedule();
        });
      };
      img.onerror = function(){ upName.textContent = /heic|heif/i.test(f.name) ? 'HEIC unsupported — use JPG/PNG' : 'Could not open this image'; };
      img.src = fr.result;
    };
    fr.readAsDataURL(f);
  });

  root.querySelector('[data-viz-removebg]').addEventListener('click', function(){
    if (!S.print) return;
    removeWhiteBg(S.print, function(clean){ S.print=clean; schedule(); });
  });

  root.querySelector('[data-viz-reset]').addEventListener('click', function(){
    S.scale=.42; S.rot=0; S.pos={x:.5,y:.40}; S.sel=true; schedule();
  });

  /* ---------- ChatGPT prompt builder ---------- */
  var copyBtn = root.querySelector('[data-viz-copy]');
  copyBtn.addEventListener('click', function(){
    var idea = (root.querySelector('[data-viz-idea]').value || 'a bold minimal graphic').trim();
    var prompt = 'Create a graphic design for apparel printing (DTF transfer). Design idea: "' + idea + '". ' +
      'Requirements: one centered composition on a PURE WHITE background — no mockups, no t-shirts, no shadows, artwork only. ' +
      'Bold clean shapes with crisp edges, limited palette of 2-4 colors that read well on dark charcoal fabric, ' +
      'no thin hairlines, no photorealistic textures, no gradients fading to white, no text unless I explicitly asked for it. ' +
      'High resolution, square format, professional screen-print / streetwear aesthetic.';
    function done(){ copyBtn.textContent = 'Copied ✓'; setTimeout(function(){ copyBtn.textContent = 'Copy ready-made prompt'; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(prompt).then(done, function(){ fallbackCopy(prompt); done(); });
    } else { fallbackCopy(prompt); done(); }
  });
  function fallbackCopy(t){
    var ta=document.createElement('textarea'); ta.value=t; ta.style.position='fixed'; ta.style.opacity='0';
    document.body.appendChild(ta); ta.select();
    try{ document.execCommand('copy'); }catch(_){}
    document.body.removeChild(ta);
  }

  /* ---------- Transform box: geometry + hit test ---------- */
  function box(){
    var pw = out.width*S.scale, ph = pw*(S.print.naturalHeight/S.print.naturalWidth);
    return { cx:S.pos.x*out.width, cy:S.pos.y*out.height, w:pw, h:ph };
  }
  function toLocal(px,py,b){
    var dx=px-b.cx, dy=py-b.cy, c=Math.cos(-S.rot), s=Math.sin(-S.rot);
    return { x:dx*c-dy*s, y:dx*s+dy*c };
  }
  function dsf(){ var r=out.getBoundingClientRect(); return r.width ? out.width/r.width : 1; }
  function canvasPt(e){ var r=out.getBoundingClientRect(); return { x:(e.clientX-r.left)*out.width/r.width, y:(e.clientY-r.top)*out.height/r.height }; }
  function hitTest(p){
    if (!S.print) return null;
    var b=box(), L=toLocal(p.x,p.y,b), ds=dsf(), R=34*ds, HIT=18*ds;
    if (S.sel && Math.hypot(L.x, L.y + b.h/2 + R) < HIT*1.2) return { mode:'rotate' };
    if (S.sel){
      var cs=[[-1,-1],[1,-1],[1,1],[-1,1]];
      for (var i=0;i<4;i++){
        if (Math.abs(L.x-cs[i][0]*b.w/2)<HIT && Math.abs(L.y-cs[i][1]*b.h/2)<HIT)
          return { mode:'scale', startDist:Math.hypot(L.x,L.y), startScale:S.scale };
      }
    }
    if (Math.abs(L.x)<b.w/2 && Math.abs(L.y)<b.h/2) return { mode:'move' };
    return null;
  }

  /* ---------- Fullscreen editing + view zoom ----------
     A "Full screen" button sits over the stage. In fullscreen the
     visitor can zoom the garment view (wheel / +/- buttons) and pan
     by dragging empty canvas. CSS transform on the canvas keeps all
     print-drag math working: canvasPt()/dsf() divide by the LIVE
     getBoundingClientRect, which already reflects the transform. */
  var stage = out.parentElement;
  var Z = { s: 1, x: 0, y: 0 };
  out.style.transformOrigin = '0 0';
  function applyZoom(){
    out.style.transform = (Z.s === 1 && !Z.x && !Z.y) ? '' :
      'translate(' + Z.x + 'px,' + Z.y + 'px) scale(' + Z.s + ')';
  }
  function resetZoom(){ Z = { s: 1, x: 0, y: 0 }; applyZoom(); }
  function isFS(){ return stage.classList.contains('is-fullscreen'); }
  function setZoom(ns, cx, cy){
    // keep the stage-point (cx,cy) fixed while scaling
    ns = Math.min(4, Math.max(1, ns));
    if (cx === undefined) { var r0 = out.getBoundingClientRect(), rs = stage.getBoundingClientRect(); cx = r0.left - rs.left + r0.width/2; cy = r0.top - rs.top + r0.height/2; }
    var k = ns / Z.s;
    Z.x = cx - (cx - Z.x) * k;
    Z.y = cy - (cy - Z.y) * k;
    Z.s = ns;
    if (Z.s === 1) { Z.x = 0; Z.y = 0; }
    applyZoom();
  }

  var ctrl = document.createElement('div');
  ctrl.className = 'viz2d__ctrl';
  ctrl.innerHTML =
    '<button type="button" class="viz2d__ctrl-btn" data-viz-zoom="out" aria-label="Zoom out">−</button>' +
    '<button type="button" class="viz2d__ctrl-btn" data-viz-zoom="in" aria-label="Zoom in">+</button>' +
    '<button type="button" class="viz2d__ctrl-btn viz2d__ctrl-btn--fs" data-viz-fs aria-label="Full screen">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="15" height="15"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>Full screen</span></button>';
  stage.appendChild(ctrl);

  // Fixed-position "fullscreen" — deterministic everywhere (iOS Safari has
  // no element fullscreen, iframes reject requestFullscreen without the
  // allowfullscreen attribute). position:fixed inset:0 gives the same UX.
  function setFS(on){
    stage.classList.toggle('is-fullscreen', on);
    document.body.style.overflow = on ? 'hidden' : '';
    if (!on) resetZoom();
    schedule(); // dsf()/hit targets depend on the on-screen size
  }
  ctrl.querySelector('[data-viz-fs]').addEventListener('click', function(){
    setFS(!isFS());
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isFS()) setFS(false);
  });
  ctrl.addEventListener('click', function(e){
    var zb = e.target.closest('[data-viz-zoom]');
    if (!zb) return;
    setZoom(zb.dataset.vizZoom === 'in' ? Z.s * 1.3 : Z.s / 1.3);
  });
  stage.addEventListener('wheel', function(e){
    if (!isFS()) return; // page scroll stays native outside fullscreen
    e.preventDefault();
    var rs = stage.getBoundingClientRect();
    setZoom(Z.s * (e.deltaY < 0 ? 1.15 : 1/1.15), e.clientX - rs.left, e.clientY - rs.top);
  }, { passive: false });

  /* ---------- Pointer: drag + select/deselect + pan ---------- */
  var drag=null;
  out.addEventListener('pointerdown', function(e){
    var p, h = null;
    if (S.print) { p = canvasPt(e); h = hitTest(p); }
    if (h){
      if (!S.sel){ S.sel=true; schedule(); }     // tap on print → frame back
      drag=h; drag.last=p;
      try{ out.setPointerCapture(e.pointerId); }catch(_){}
      e.preventDefault();
    } else {
      if (S.sel){ S.sel=false; schedule(); }     // tap outside → hide frame
      if (Z.s > 1){                              // zoomed-in: drag empty area = pan
        drag={ mode:'pan', lx:e.clientX, ly:e.clientY };
        try{ out.setPointerCapture(e.pointerId); }catch(_){}
        e.preventDefault();
      }
    }
  });
  out.addEventListener('pointermove', function(e){
    if (!drag) return;
    if (drag.mode==='pan'){
      Z.x += e.clientX - drag.lx; Z.y += e.clientY - drag.ly;
      drag.lx = e.clientX; drag.ly = e.clientY;
      applyZoom();
      return;
    }
    var p=canvasPt(e), b=box();
    if (drag.mode==='move'){
      S.pos.x=Math.min(.97,Math.max(.03,S.pos.x+(p.x-drag.last.x)/out.width));
      S.pos.y=Math.min(.97,Math.max(.03,S.pos.y+(p.y-drag.last.y)/out.height));
      drag.last=p;
    } else if (drag.mode==='scale'){
      var L=toLocal(p.x,p.y,b);
      S.scale=Math.min(.95,Math.max(.06,drag.startScale*Math.hypot(L.x,L.y)/Math.max(1,drag.startDist)));
    } else if (drag.mode==='rotate'){
      S.rot=Math.atan2(p.y-b.cy,p.x-b.cx)+Math.PI/2;
    }
    schedule();
  });
  function endDrag(){ drag=null; }
  out.addEventListener('pointerup', endDrag);
  out.addEventListener('pointercancel', endDrag);

  /* ---------- rAF throttle ---------- */
  var raf=false;
  function schedule(){
    if(raf)return;
    raf=true;
    // setTimeout fires even in background tabs / preview iframes where rAF is throttled.
    // 16 ms ≈ one 60 fps frame — negligible for static updates, smooth enough for drag.
    setTimeout(function(){ raf=false; render(); }, 16);
  }

  /* ---------- Box blur ×3 (Safari-safe) ---------- */
  function blurMap(map,w,h,r){ if(r<1)return map; var a=map,b=new Float32Array(w*h);
    for(var p=0;p<3;p++){ boxH(a,b,w,h,r); boxV(b,a,w,h,r);} return a; }
  function boxH(s,d,w,h,r){ var ia=1/(r+r+1);
    for(var i=0;i<h;i++){ var ti=i*w,li=ti,ri=ti+r,fv=s[ti],lv=s[ti+w-1],val=(r+1)*fv,j;
      for(j=0;j<r;j++)val+=s[ti+j];
      for(j=0;j<=r;j++){val+=s[ri++]-fv;d[ti++]=val*ia;}
      for(j=r+1;j<w-r;j++){val+=s[ri++]-s[li++];d[ti++]=val*ia;}
      for(j=w-r;j<w;j++){val+=lv-s[li++];d[ti++]=val*ia;} } }
  function boxV(s,d,w,h,r){ var ia=1/(r+r+1);
    for(var i=0;i<w;i++){ var ti=i,li=ti,ri=ti+r*w,fv=s[ti],lv=s[ti+w*(h-1)],val=(r+1)*fv,j;
      for(j=0;j<r;j++)val+=s[ti+j*w];
      for(j=0;j<=r;j++){val+=s[ri]-fv;d[ti]=val*ia;ri+=w;ti+=w;}
      for(j=r+1;j<h-r;j++){val+=s[ri]-s[li];d[ti]=val*ia;li+=w;ri+=w;ti+=w;}
      for(j=h-r;j<h;j++){val+=lv-s[li];d[ti]=val*ia;li+=w;ti+=w;} } }

  function buildMap(){
    try {
      var w=out.width,h=out.height,c=document.createElement('canvas');c.width=w;c.height=h;
      var cc=c.getContext('2d',{willReadFrequently:true}); cc.drawImage(S.garment,0,0,w,h);
      var d=cc.getImageData(0,0,w,h).data, map=new Float32Array(w*h);
      for(var i=0,j=0;i<d.length;i+=4,j++) map[j]=(0.299*d[i]+0.587*d[i+1]+0.114*d[i+2])/255;
      S.map=blurMap(map,w,h,BLUR);
    } catch(e) {
      // Tainted canvas (image loaded without CORS from another origin, or
      // file://) — pixel access is blocked. Fall back to flat compositing:
      // the garment photo and the print still render, just without the
      // fabric-fold simulation.
      S.map='flat';
    }
  }

  /* ---------- Render ---------- */
  function render(){
    if(!S.garment || !S.garment.naturalWidth) return;
    var w=out.width,h=out.height;
    ctx.clearRect(0,0,w,h); ctx.drawImage(S.garment,0,0,w,h);
    if (tip) tip.style.display = S.print ? 'none' : '';
    if(!S.print) return;
    if(!S.map) buildMap();
    if(S.map==='flat'){
      // Tainted-canvas fallback: plain transformed print, no fold simulation.
      var fb=box();
      ctx.save(); ctx.translate(fb.cx,fb.cy); ctx.rotate(S.rot);
      ctx.globalAlpha=0.96;
      ctx.drawImage(S.print,-fb.w/2,-fb.h/2,fb.w,fb.h);
      ctx.restore(); ctx.globalAlpha=1;
      if(S.sel) drawUI(fb);
      return;
    }
    var map=S.map;

    var pc=document.createElement('canvas');pc.width=w;pc.height=h;
    var pctx=pc.getContext('2d',{willReadFrequently:true});
    var b=box();
    pctx.save();pctx.translate(b.cx,b.cy);pctx.rotate(S.rot);
    pctx.drawImage(S.print,-b.w/2,-b.h/2,b.w,b.h);pctx.restore();

    var sd=pctx.getImageData(0,0,w,h).data;
    var dim=ctx.createImageData(w,h),dd=dim.data;
    for(var y=1;y<h-1;y++){var row=y*w;
      for(var x=1;x<w-1;x++){var i=row+x;
        var sx=Math.round(x-(map[i+1]-map[i-1])*DISP);
        var sy=Math.round(y-(map[i+w]-map[i-w])*DISP);
        if(sx<0||sy<0||sx>=w||sy>=h)continue;
        var si=(sy*w+sx)*4;if(sd[si+3]===0)continue;
        var di=i*4;dd[di]=sd[si];dd[di+1]=sd[si+1];dd[di+2]=sd[si+2];dd[di+3]=sd[si+3];}}
    /* shading: luminance multiply + crease-EDGE darkening (the fold-transition fix) */
    for(var y2=1;y2<h-1;y2++){var row2=y2*w;
      for(var x2=1;x2<w-1;x2++){var p=row2+x2, i2=p*4;
        var a=dd[i2+3];if(a===0)continue;
        var L=map[p];
        var gmag=Math.abs(map[p+1]-map[p-1])+Math.abs(map[p+w]-map[p-w]);
        var m=1-SHADE*(0.5-L)*1.6;
        m*=1-Math.min(1,gmag*7)*0.30;            // edges of folds bite into the ink
        if(m<0.20)m=0.20;if(m>1.35)m=1.35;
        dd[i2]*=m;dd[i2+1]*=m;dd[i2+2]*=m;
        if(L<0.40) dd[i2+3]=a*(1-TEXTURE*(0.40-L)*2.0);}}
    var tmp=document.createElement('canvas');tmp.width=w;tmp.height=h;
    tmp.getContext('2d').putImageData(dim,0,0);
    ctx.drawImage(tmp,0,0);

    if(S.sel) drawUI(b);
  }

  /* ---------- Transform frame ---------- */
  function drawUI(b){
    var ds=dsf(), HS=8*ds, R=34*ds;
    ctx.save(); ctx.translate(b.cx,b.cy); ctx.rotate(S.rot);
    ctx.setLineDash([6*ds,5*ds]); ctx.lineWidth=1.4*ds;
    ctx.strokeStyle='rgba(232,230,225,.9)';
    ctx.strokeRect(-b.w/2,-b.h/2,b.w,b.h);
    ctx.setLineDash([]);
    var cs=[[-1,-1],[1,-1],[1,1],[-1,1]];
    for(var i=0;i<4;i++){
      var cx=cs[i][0]*b.w/2, cy=cs[i][1]*b.h/2;
      ctx.fillStyle='#B59A6A'; ctx.strokeStyle='#151918'; ctx.lineWidth=1.5*ds;
      ctx.fillRect(cx-HS,cy-HS,HS*2,HS*2); ctx.strokeRect(cx-HS,cy-HS,HS*2,HS*2);
    }
    ctx.strokeStyle='rgba(232,230,225,.7)'; ctx.lineWidth=1.2*ds;
    ctx.beginPath(); ctx.moveTo(0,-b.h/2); ctx.lineTo(0,-b.h/2-R+12*ds); ctx.stroke();
    ctx.fillStyle='#B59A6A'; ctx.beginPath(); ctx.arc(0,-b.h/2-R,12*ds,0,Math.PI*2); ctx.fill();
    ctx.strokeStyle='#151918'; ctx.lineWidth=2*ds;
    ctx.beginPath(); ctx.arc(0,-b.h/2-R,5.5*ds,-Math.PI*0.25,Math.PI*1.1); ctx.stroke();
    ctx.restore();
  }

  /* ---------- Boot: load the currently displayed garment photo ---------- */
  (function() {
    // data-init-url on the container → explicit seed (e.g. on index.html demo)
    var initUrl = root.dataset.initUrl;
    if (initUrl) {
      loadGarmentFromUrl(initUrl, root.dataset.initHex || null);
      return;
    }
    // product.html: mirror the current main product image
    var mainImg = document.getElementById('cz-main-img');
    if (mainImg && mainImg.src) {
      loadGarmentFromUrl(mainImg.src, null);
    }
    // ptah:garment-changed keeps the canvas current when color/garment changes
  })();
})();
